import { createContext, useContext, useState } from "react";

const CICustomBottlerSelectionContext = createContext();

// Context Provider Component
export const CICustomBottlerSelectionProvider = ({ children }) => {
  const [customSelectedData, setCustomSelectedData] = useState([]);

  return (
    <CICustomBottlerSelectionContext.Provider
      value={{ customSelectedData, setCustomSelectedData }}
    >
      {children}
    </CICustomBottlerSelectionContext.Provider>
  );
};

// Custom Hook for easy access
export const useCICustomBottlerSelection = () =>
  useContext(CICustomBottlerSelectionContext);
